<script>
	import { onMount } from 'svelte';
	import { goto } from '@roxi/routify';
	import SvelteTable from "svelte-table";
	import { getGETAPILink, getData, postFormData, capitalizeFirstLetter, postJsonData } from "../helpers.js";
	import Navbar from "../components/Navbar.svelte";
	import Footer from "../components/Footer.svelte";
	
	let [dirProjectIdError, pwcrNumberError, awardingBodyError, contractorError, projectNameError, countyError, startDateError, endDateError, sortByError, sepNPError, scrapePDFsError, includePDFsError, generateContractorTreeError, limitBypassError, useV2ParserError, localSearchError] = ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''];
	let [dirProjectId, pwcrNumber, awardingBody, contractor, projectName, county, startDate, endDate, sortByInput, sepNP, scrapePDFs, includePDFs, generateContractorTree, limitBypass, useV2Parser, localSearch] = ['', '', '', '', '', '', '', '', '', false, true, false, false, false, true, true];
	let searchState = 'preview-search'; // default: preview-search

	// Get enabled paywall feature-set
	let [contractorTreeFeature, limitBypassFeature] = [false, false];
	getData('user/paywall-features').then(response => response.json()).then(ret_json => {
		if (ret_json.status === 'success') {
			contractorTreeFeature = generateContractorTree = ret_json.features.includes('GENERATE_CONTRACTOR_TREE');
			limitBypassFeature = ret_json.features.includes('BYPASS_250_LIMIT');
		} else {
			otherError = 'Unknown Error Occured. Check Connection?';
		}
	});

	let otherError = '';
	let previewDataNotice = ''
	let searchForm;
	let previewSubmit = false;
	// POSTs for preview data then either fills in errors or loads preview-data page. 
	function handlePreview() {
		if (limitBypass) {
			handleSearch();
			return;
		}
		let res = postFormData('ecpr-search/preview', searchForm);
		previewSubmit = true;
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				otherError = '';
				if (ret_json.entries.status === 'success') {
					previewData = ret_json.entries.data.map((row, index) => {
						row.id = index;
						return row;
					});
					if (ret_json.entries.dataFiltered == 1) {
						previewDataNotice = (ret_json.entries.dataFiltered + ' result not shown due to permissions.');
					} else if (ret_json.entries.dataFiltered > 1) {
						previewDataNotice = (ret_json.entries.dataFiltered + ' results not shown due to permissions.');
					} else {
						previewDataNotice = '';
					};
					searchState = 'preview-data';
				} else if (ret_json.entries.status === 'error') {
					otherError = ret_json.entries.error;
					if (ret_json.entries.dataFiltered == 1) {
						otherError += ('. ' + ret_json.entries.dataFiltered + ' result not shown due to permissions.');
					} else if (ret_json.entries.dataFiltered > 1) {
						otherError += ('. ' + ret_json.entries.dataFiltered + ' results not shown due to permissions.');
					};
					dirProjectIdError = '';
					pwcrNumberError = '';
					awardingBodyError = '';
					contractorError = '';
					projectNameError = '';
					countyError = '';
					startDateError = '';
					endDateError = '';
					sortByError = '';
					sepNPError = '';
				} else {
					otherError = 'An unknown error has occured. Please try again.';
				}
			} else if (ret_json.status === 'error') {
				if (ret_json.error === 'Account not valid.') {
					otherError = 'Account not valid, please update payment information';
				} else {
					otherError = '';
					let errors = ret_json.error;
					dirProjectIdError = errors.proj_id ? errors.proj_id[0] : '';
					pwcrNumberError = errors.pwcr_num ? errors.pwcr_num[0] : '';
					awardingBodyError = errors.awarding_body ? errors.awarding_body[0] : '';
					contractorError = errors.contractor ? errors.contractor[0] : '';
					projectNameError = errors.proj_name ? errors.proj_name[0] : '';
					countyError = errors.county ? errors.county[0] : '';
					startDateError = errors.start_date ? errors.start_date[0] : '';
					endDateError = errors.end_date ? errors.end_date[0] : '';
					sortByError = errors.sort_by ? errors.sort_by[0] : '';
					sepNPError = errors.sep_np ? errors.sep_np[0] : '';
				}
			} else {
				otherError = 'An unknown error has occured. Please try again.';
			}
			previewSubmit = false;
		}).catch(() => {
			otherError = 'An unknown error has occured. Please try again.';
			previewSubmit = false;
		});
	}
	
	// BEGIN PREVIEW CODE 
	let sortBy = "id";
	let sortOrder = 1;
	let iconAsc = "↑";
	let iconDesc = "↓";
	let numRows = 20;
	let previewData = [];

	const COLUMNS = {
		id: {
			key: "id",
			value: v => v.id,
		},
		submissionDate: {
			key: "submissionDate",
			title: "Entry Date",
			value: v => v.submissionDate,
			sortable: true,
			filterOptions: rows => {
				let dates = {};
				rows.forEach(row => {
				let date = row.submissionDate;
				if (dates[date] === undefined)
					dates[date] = {
					name: date,
					value: date
					};
				});

				dates = Object.entries(dates)
				.sort()
				.reduce((o, [k, v]) => ((o[k] = v), o), {});
				return Object.values(dates);
			},
			filterValue: v => v.submissionDate,
			headerClass: "bg-gray-200",
			headerFilterClass: "pb-2",
		},
		forWeekEnding: {
			key: "forWeekEnding",
			title: "Week Ending Date",
			value: v => v.forWeekEnding,
			sortable: true,
			filterOptions: rows => {
				let dates = {};
				rows.forEach(row => {
				let date = row.forWeekEnding;
				if (dates[date] === undefined)
					dates[date] = {
					name: date,
					value: date
					};
				});
				dates = Object.entries(dates)
				.sort()
				.reduce((o, [k, v]) => ((o[k] = v), o), {});
				return Object.values(dates);
			},
			filterValue: v => v.forWeekEnding,
			headerClass: "bg-gray-200",
			headerFilterClass: "pb-2",
		},
		projectID: {
			key: "projectID",
			title: "DIR Project ID",
			value: v => v.projectID,
			sortable: true,
			filterOptions: rows => {
				let ids = {};
				rows.forEach(row => {
				let id = row.projectID;
				if (ids[id] === undefined)
					ids[id] = {
					name: id,
					value: id
					};
				});
				ids = Object.entries(ids)
				.sort()
				.reduce((o, [k, v]) => ((o[k] = v), o), {});
				return Object.values(ids);
			},
			filterValue: v => v.projectID,
			headerClass: "bg-gray-200",
			headerFilterClass: "pb-2",
		},
		projectName: {
			key: "projectName",
			title: "Project Name",
			value: v => v.projectName,
			sortable: true,
			headerClass: "bg-gray-200",
		},
		awardingBody: {
			key: "awardingBody",
			title: "Awarding Body",
			value: v => v.awardingBody,
			sortable: true,
			headerClass: "bg-gray-200",
		},
		contractorName: {
			key: "contractorName",
			title: "Contractor Name",
			value: v => v.contractorName,
			sortable: true,
			headerClass: "bg-gray-200",
		},
		payrollNumAmendNum: {
			key: "payrollNumAmendNum",
			title: "Payroll Number",
			value: v => v.payrollNumAmendNum,
			sortable: true,
			headerClass: "bg-gray-200 mt-2",
		}
	};
	let selectedDesktopCols = ["submissionDate", "forWeekEnding", "projectID", "projectName", "awardingBody", "contractorName", "payrollNumAmendNum"];
	$: desktopCols = selectedDesktopCols.map(key => COLUMNS[key]);
	let selectedMobileCols = ["forWeekEnding", "contractorName", "payrollNumAmendNum"];
	$: mobileCols = selectedMobileCols.map(key => COLUMNS[key]);

	let expandedArr = [];
	function handleRowClick(event) {
		// manually toggle expanded items
		const row = event.detail.row;
		if (!row.$expanded) {
			expandedArr = [...expandedArr, row.id];
		} else {
			expandedArr = expandedArr.filter(id => id !== row.id);
		}
	}

	// $: limitBypass, console.log(limitBypass);

	let searchId = '';
	let searchSubmit = false;
	function handleSearch() {
		let res = '';
		if (limitBypass) {
			res = postFormData('ecpr-search/bulk-submit', searchForm);
		} else {
			res = postFormData('ecpr-search/submit', searchForm);
		}
		searchSubmit = true;
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				otherError = '';
				searchId = ret_json.search_id;
				searchState = 'aggregating-results';
				setTimeout(updateSearchStatus(searchId), 750); // Prevent Invalid Search ID
			} else if (ret_json.status === 'error') {
				if (ret_json.error === 'Account not valid.') {
					otherError = 'Account not valid, please update payment information';
				} else {
					otherError = 'Error(s) occured, please fix before continuing';
					let errors = ret_json.error;
					dirProjectIdError = errors.proj_id ? errors.proj_id[0] : '';
					pwcrNumberError = errors.pwcr_num ? errors.pwcr_num[0] : '';
					awardingBodyError = errors.awarding_body ? errors.awarding_body[0] : '';
					contractorError = errors.contractor ? errors.contractor[0] : '';
					projectNameError = errors.proj_name ? errors.proj_name[0] : '';
					countyError = errors.county ? errors.county[0] : '';
					startDateError = errors.start_date ? errors.start_date[0] : '';
					endDateError = errors.end_date ? errors.end_date[0] : '';
					sortByError = errors.sort_by ? errors.sort_by[0] : '';
					sepNPError = errors.sep_np ? errors.sep_np[0] : '';
				}
			} else {
				otherError = 'An unknown error has occured. Please try again.';
			}
			searchSubmit = false;
		}).catch(() => {
			otherError = 'An unknown error has occured. Please try again.';
			searchSubmit = false;
		});
	}

	let searchStatus = 'downloading';
	let downloadedFiles = 0;
	let totalFiles = 0;
	let statusTimeoutID;
	function updateSearchStatus(searchId) {
		let res = getData('ecpr-search/status', {search_id: searchId});
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				searchStatus = ret_json.search_status;
				if (ret_json.search_status === 'downloading') {
					downloadedFiles = ret_json.downloaded_files;
					totalFiles = ret_json.total_files;
					statusTimeoutID = setTimeout(updateSearchStatus, 5000, searchId); // 5 sec for delay
				} else if (ret_json.search_status === 'sorting') {
					statusTimeoutID = setTimeout(updateSearchStatus, 3000, searchId); // 3 sec for delay
				} else if (ret_json.search_status === 'zipping') {
					statusTimeoutID = setTimeout(updateSearchStatus, 2500, searchId); // 2.5 sec for delay
				} else if (ret_json.search_status === 'finished') {
					// No callback, finished; TODO(?)
				} else if (ret_json.search_status === 'scraping') {
					statusTimeoutID = setTimeout(updateSearchStatus, 2000, searchId); // 2.0 sec for delay
				} else {
					searchStatus = ''; // unk error
					otherError = 'An unknown error has occured. Please try again.';
				}
			} else {
				otherError = ret_json.error;
			}
		});
	}

	let cancelSubmit = false;
	function cancelSearch(searchId) {
		let res = postJsonData('ecpr-search/cancel', {'search_id': searchId});
		cancelSubmit = true;
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				clearTimeout(statusTimeoutID);
				searchState = 'preview-search';
				previewData = []
			} else if (ret_json.status === 'error') {
				otherError = ret_json.error;
			}
			cancelSubmit = false;
		});
	}

	function newSearch() {
		searchState = 'preview-search'; // default
		searchStatus = 'downloading'; // default
		searchId = '';
		previewData = [];
		searchSubmit = false;
		otherError = '';
		[dirProjectId, pwcrNumber, awardingBody, contractor, projectName, county, startDate, endDate, sortByInput, sepNP, scrapePDFs, includePDFs, generateContractorTree] = ['', '', '', '', '', '', '', '', '', false, true, false, contractorTreeFeature];
		[dirProjectIdError, pwcrNumberError, awardingBodyError, contractorError, projectNameError, countyError, startDateError, endDateError, sortByError, sepNPError, scrapePDFsError, includePDFsError, generateContractorTreeError] = ['', '', '', '', '', '', '', '', '', '', '', '', ''];
	}
</script>

<main class=background>
	<Navbar/>
	<div class="flex flex-col space-y-4 mt-10 items-center lg:flex-row lg:justify-center">
		<div class="mx-2 !mb-4 px-10 py-12 max-w-6xl w-full flex-1 card">
			<!-- Use hidden to preserve form state instead of discarding -->
			<div class="hidden lg:block"> <!-- Cheap way out, especially since layout change on desktop-->
				<div class="{searchState === 'preview-search' ? '' : 'hidden'}">
					<p class="text-2xl font-semibold text-blue-900 mb-8">Search for eCPR Documents</p>
					<p class="text-red-500 {otherError === '' ? '' : 'text-xl pb-5'}">{otherError}</p>
					<form method="POST" class="h-full relative" bind:this={searchForm} on:submit|preventDefault={handlePreview}>
						<!-- <input id="csrf_token" name="csrf_token" value="" class="hidden"> -->
						<div class="flex flex-col space-y-4 text-xl">
							<div class="flex space-x-4">
								<div class='input w-1/2'>
									<div class="relative">
										<input id="dir-project-id" name="proj_id" bind:value={dirProjectId} placeholder="DIR Project ID" class="peer z-20 placeholder:text-transparent {dirProjectIdError === '' ? '' : 'border-red-600'}"/>
										<label for="dir-project-id" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">DIR Project ID</label>
									</div>
									<p class="error-text {dirProjectIdError === '' ? 'hidden' : ''}">{dirProjectIdError}</p>
								</div>
								<div class='input w-1/2'>
									<div class="relative">
										<input id="pwcr-number" name="pwcr_num" bind:value={pwcrNumber} placeholder="PWCR Number" class="peer z-20 placeholder:text-transparent  {pwcrNumberError === '' ? '' : 'border-red-600'}"/>
										<label for="pwcr-number" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">PWCR Number</label>
									</div>
									<p class="error-text {pwcrNumberError === '' ? 'hidden' : ''}">{pwcrNumberError}</p>
								</div>
							</div>
							<div class="flex space-x-4">
								<div class='input w-1/2'>
									<div class="relative">
										<input id="awarding-body" name="awarding_body" bind:value={awardingBody} placeholder="Awarding Body" class="peer z-20 placeholder:text-transparent {awardingBodyError === '' ? '' : 'border-red-600'}"/>
										<label for="awarding-body" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Awarding Body</label>
									</div>
									<p class='error-text {awardingBodyError === '' ? 'hidden' : ''}'>{awardingBodyError}</p>
								</div>
								<div class='input w-1/2'>
									<div class="relative">
										<input id="contractor" name="contractor" bind:value={contractor} placeholder="Contractor Name" class="peer z-20 placeholder:text-transparent  {contractorError === '' ? '' : 'border-red-600'}"/>
										<label for="contractor" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Contractor</label>
									</div>
									<p class='error-text {contractorError === '' ? 'hidden' : ''}'>{contractorError}</p>
								</div>
							</div>
							<div class="flex space-x-4">
								<div class='input w-1/2'>
									<div class="relative">
										<input id="project-name" name="proj_name" bind:value={projectName} placeholder="Project Name" class="peer z-20 placeholder:text-transparent  {projectNameError === '' ? '' : 'border-red-600'}"/>
										<label for="project-name" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Project Name</label>
									</div>
									<p class='error-text {projectNameError === '' ? 'hidden' : ''}'>{projectNameError}</p>
								</div>
								<div class='input w-1/2'>
									<div class="relative">
										<select id="county" name="county" bind:value={county} class="input-field peer mt-4 {countyError === '' ? '' : 'border-red-600'} w-full">
											<option value="">Select a County</option><option value="Out of state:">Out of state:</option><option value="Alameda">Alameda</option><option value="Alpine">Alpine</option><option value="Amador ">Amador </option><option value="Butte">Butte</option><option value="Calaveras">Calaveras</option><option value="Colusa">Colusa</option><option value="Contra costa">Contra costa</option><option value="Del Norte">Del Norte</option><option value="El Dorado">El Dorado</option><option value="Fresno">Fresno</option><option value="Glenn">Glenn</option><option value="Humboldt">Humboldt</option><option value="Imperial">Imperial</option><option value="Inyo">Inyo</option><option value="Kern">Kern</option><option value="Kings">Kings</option><option value="Lake">Lake</option><option value="Lassen">Lassen</option><option value="Los Angeles">Los Angeles</option><option value="Madera">Madera</option><option value="Marin">Marin</option><option value="Mariposa">Mariposa</option><option value="Mendocino">Mendocino</option><option value="Merced">Merced</option><option value="Modoc">Modoc</option><option value="Mono">Mono</option><option value="Monterey">Monterey</option><option value="Napa">Napa</option><option value="Nevada">Nevada</option><option value="Orange">Orange</option><option value="Placer">Placer</option><option value="Plumas">Plumas</option><option value="Riverside">Riverside</option><option value="Sacramento">Sacramento</option><option value="San Benito">San Benito</option><option value="San Bernardino">San Bernardino</option><option value="San Diego">San Diego</option><option value="San Francisco">San Francisco</option><option value="San Joaquin">San Joaquin</option><option value="San Luis Obispo">San Luis Obispo</option><option value="San Mateo">San Mateo</option><option value="Santa Barbara">Santa Barbara</option><option value="Santa Clara">Santa Clara</option><option value="Santa Cruz">Santa Cruz</option><option value="Shasta">Shasta</option><option value="Sierra">Sierra</option><option value="Siskiyou">Siskiyou</option><option value="Solano">Solano</option><option value="Sonoma">Sonoma</option><option value="Stanislaus">Stanislaus</option><option value="Sutter">Sutter</option><option value="Tehama">Tehama</option><option value="Trinity">Trinity</option><option value="Tulare">Tulare</option><option value="Tuolumne">Tuolumne</option><option value="Ventura">Ventura</option><option value="Yolo">Yolo</option><option value="Yuba">Yuba</option>
										</select>
										<label for="county" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">County</label>
									</div>
									<p class='error-text {countyError === '' ? 'hidden' : ''}'>{countyError}</p>
								</div>
							</div>
							<div class="flex space-x-4">
								<div class='input w-1/2'>
									<div class="relative">
										<input id="start-date" name="start_date" bind:value={startDate} placeholder="Start Date" type='date' class="{startDateError === '' ? '' : 'border-red-600'}"/>
										<label for="start-date" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Start Date</label>
									</div>
									<p class='error-text {startDateError === '' ? 'hidden' : ''}'>{startDateError}</p>
								</div>
								<div class='input w-1/2'>
									<div class="relative">
										<input id="end-date" name="end_date" bind:value={endDate} placeholder="End Date" type='date' class="{endDateError === '' ? '' : 'border-red-600'}"/>
										<label for="end-date" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">End Date</label>
									</div>
									<p class='error-text {endDateError === '' ? 'hidden' : ''}'>{endDateError}</p>
								</div>
							</div>
							<div class="flex space-x-4">
								<div class='input w-1/3'>
									<div class="relative">
										<select id="sort_by" name="sort_by" bind:value={sortByInput} class="input-field w-full mt-4 {sortByError === '' ? '' : 'border-red-600'}">
											<option value="">Select a Sort Filter</option><option value="DIR Project ID">DIR Project ID</option><option value="Awarding Body">Awarding Body</option><option value="Contractor Name">Contractor Name</option><option value="Project Name">Project Name</option><option value="Date">Date</option><option value="Contractor PWCR">Contractor PWCR</option><option value="County">County</option><option value="CSLB License">CSLB License</option>
										</select>
										<label for="sort_by" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">Sort By</label>
									</div>
									<p class='error-text {sortByError === '' ? 'hidden' : ''}'>{sortByError}</p>
								</div>
								<div class="input inline-block w-1/3">
									<div class="flex my-auto text-lg space-x-4 {sepNPError === '' ? '' : 'border-red-600'}">
										<input id="separate-np" name="sep_np" bind:checked={sepNP} type="checkbox" class="w-5"/>
										<label for="separate-np">Separate Non-Performance Statements</label>
										<p class='error-text {sepNPError === '' ? 'hidden' : ''}'>{sepNPError}</p>
									</div>
									<div class="flex my-auto text-lg space-x-4 {contractorTreeFeature ? '' : 'hover:cursor-not-allowed'} {generateContractorTreeError === '' ? '' : 'border-red-600'}">
										<input id="generate-contractor-tree" name="generate_contractor_tree" bind:checked={generateContractorTree} disabled={!contractorTreeFeature} type="checkbox" class="w-5"/>
										<label for="generate-contractor-tree" class="{contractorTreeFeature ? '' : 'text-gray-500'}">Generate Contractor Tree</label>
										<p class='error-text {generateContractorTreeError === '' ? 'hidden' : ''}'>{generateContractorTreeError}</p>
									</div>
								</div>
								<div class="input inline-block w-1/3">
									<div class="flex my-auto text-lg space-x-4 {scrapePDFsError === '' ? '' : 'border-red-600'}">
										<input id="scrape-pdfs" name="scrape_pdfs" bind:checked={scrapePDFs} type="checkbox" class="w-5"/>
										<label for="scrape-pdfs">Scrape PDFs to CSV</label>
										<p class='error-text {scrapePDFsError === '' ? 'hidden' : ''}'>{scrapePDFsError}</p>
									</div>
									<div class="flex my-auto text-lg space-x-4 {includePDFsError === '' ? '' : 'border-red-600'}">
										<input id="include-pdfs" name="include_pdfs" bind:checked={includePDFs} type="checkbox" class="w-5"/>
										<label for="include-pdfs">Include PDFs</label>
										<p class='error-text {includePDFsError === '' ? 'hidden' : ''}'>{includePDFsError}</p>
									</div>
								</div>
							</div>
							<div class="flex space-x-8">
								{#if limitBypassFeature}
									<div class="flex my-auto text-lg space-x-4 {limitBypassError === '' ? '' : 'border-red-600'}">
										<input id="limit-bypass" name="limit-bypass" bind:checked={limitBypass} type="checkbox" class="w-5"/>
										<label for="limit-bypass">BETA - 250 Limit Bypass</label>
										<p class='error-text {limitBypassError === '' ? 'hidden' : ''}'>{limitBypassError}</p>
									</div>
								{/if}
								<div class="flex my-auto text-lg space-x-4 {useV2ParserError === '' ? '' : 'border-red-600'}">
									<input id="use-v2-parser" name="use_v2_parser" bind:checked={useV2Parser} type="checkbox" class="w-5"/>
									<label for="use-v2-parser">BETA - Use v2 Parser</label>
									<p class='error-text {useV2ParserError === '' ? 'hidden' : ''}'>{useV2ParserError}</p>
								</div>
								<div class="tooltip-div">
									<div class="flex my-auto text-lg space-x-4 {localSearchError === '' ? '' : 'border-red-600'}">
										<input id="local-search" name="local_search" bind:checked={localSearch} type="checkbox" class="w-5"/>
										<label for="local-search">BETA - Local Search</label>
										<p class='error-text {localSearchError === '' ? 'hidden' : ''}'>{localSearchError}</p>
									</div>
									<p class='tooltip'>Searches through cache, does not pull new results.</p>
								</div>
							</div>
							<input type="submit" value="Submit" disabled={previewSubmit}
								class="w-4/12 pl-0 pb-2 pt-1 text-xl rounded-md bg-blue-500 disabled:bg-blue-500 disabled:text-white hover:bg-blue-700 cursor-pointer disabled:cursor-wait text-white font-semibold border-none shadow-sm">
						</div>
					</form>
				</div>
				<div class="{searchState === 'preview-data' ? '' : 'hidden'}">
					<p class="text-2xl font-semibold text-blue-900">Preview eCPR Documents</p>
					<p class="text-lg font-semibold text-blue-900 mb-4">Click on a row to preview PDF.</p>
					<p class="text-red-500 {otherError === '' ? '' : 'text-xl pb-5'}">{otherError}</p>
					<p class="text-blue-600 {previewDataNotice === '' ? 'hidden' : 'text-lg pb-2'}">{previewDataNotice}</p>
					<p class="text-lg mb-3">{previewData.length} {previewData.length == 1 ? "result" : "results"}</p>
					<div class="overflow-auto max-h-[50vh]">
						<SvelteTable
							columns={desktopCols}
							rows={previewData}
							classNameRow={'cursor-pointer odd:bg-white even:bg-gray-200'}
							classNameThead={['table-primary sticky top-0 bg-white']}
							classNameTbody={['w-full overflow-scroll']}
							classNameSelect={['rounded-md shadow-sm font-thin py-1 px-2']}
							on:clickRow={(event) => {
								let row = event.detail.row;
								document.getElementById("TID").value = row.tranId;
								document.getElementById("PAN").value = row.payrollNumAmendNum;
								document.getElementById("getPDF").submit();
							}}
						/>
					</div>
					<form id="getPDF" action="https://efiling.dir.ca.gov/eCPR/ActionServlet?action=getCertPayrollRecords" target="_blank" method="post" class="hidden">
						<input type="hidden" id="TID" name="TID" value="">
						<input type="hidden" id="RM" name="RM" value="">
						<input type="hidden" id="PAN" name="PAN" value="">
					</form>
					<div class="inline-block w-full mt-4">
						<button on:click={() => {searchState = 'preview-search'; previewData = []; otherError = ''}}
							class="w-2/12 pl-0 pb-2 pt-1 text-xl rounded-md bg-blue-500 disabled:bg-blue-300 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
						Back</button>
						<button on:click={handleSearch} disabled={searchSubmit}
							class="float-right w-3/12 pl-0 pb-2 pt-1 text-xl rounded-md bg-blue-500 disabled:bg-blue-300 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
						Submit Search</button>
					</div>
				</div>
				<div class="{searchState === 'aggregating-results' ? '' : 'hidden'}">
					<p class="text-2xl font-semibold text-blue-900">Aggregating Results</p>
					<p class="text-red-500 {otherError === '' ? '' : 'text-xl pb-5'}">{otherError}</p>
					<div class="mt-5 space-y-3">
						<p class="text-xl font-semibold">Search ID: {searchId}</p>
						<p class="text-xl font-semibold">Status: {capitalizeFirstLetter(searchStatus)}</p>
						{#if searchStatus === 'downloading'}
							<p class="text-xl font-semibold">Files downloaded: {downloadedFiles} out of {totalFiles}</p>
						{:else if searchStatus === 'finished'}
							<div class="space-x-5 mt-5">
								<a href="{getGETAPILink('ecpr-search/download', {'search_id': searchId})}" download="{searchId}.zip" target="_self">
								<button
									class="w-2/12 pl-0 pb-2 pt-2 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
								Download</button></a>
								<button on:click={newSearch}
									class="w-2/12 pl-0 pb-2 pt-2 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
								New Search</button>
							</div>
						{/if}
						{#if (searchStatus !== 'finished') && (searchStatus !== 'error')}
							<div class="inline-block w-full mt-5">
								<button on:click={() => cancelSearch(searchId)} disabled={cancelSubmit}
									class="w-2/12 pl-0 pb-2 pt-1 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
								Cancel</button>
							</div>
						{/if}
					</div>
				</div>
			</div>
			<div class="block lg:hidden"> 
				<div class="{searchState === 'preview-search' ? '' : 'hidden'}">
					<p class="text-2xl font-semibold text-blue-900 mb-8">Search for eCPR Documents</p>
					<p class="text-red-500 {otherError === '' ? '' : 'text-xl pb-5'}">{otherError}</p>
					<form method="POST" class="h-full relative" bind:this={searchForm} on:submit|preventDefault={handlePreview}>
						<!-- <input id="csrf_token" name="csrf_token" value="" class="hidden"> -->
						<div class="flex flex-col space-y-4 text-xl">
							<div class='input'>
								<div class="relative">
									<input id="dir-project-id-mobile" name="proj_id" bind:value={dirProjectId} placeholder="DIR Project ID" class="peer z-20 placeholder:text-transparent {dirProjectIdError === '' ? '' : 'border-red-600'}"/>
									<label for="dir-project-id-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">DIR Project ID</label>
								</div>
								<p class="error-text {dirProjectIdError === '' ? 'hidden' : ''}">{dirProjectIdError}</p>
							</div>
							<div class='input'>
								<div class="relative">
									<input id="pwcr-number-mobile" name="pwcr_num" bind:value={pwcrNumber} placeholder="PWCR Number" class="peer z-20 placeholder:text-transparent  {pwcrNumberError === '' ? '' : 'border-red-600'}"/>
									<label for="pwcr-number-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">PWCR Number</label>
								</div>
								<p class="error-text {pwcrNumberError === '' ? 'hidden' : ''}">{pwcrNumberError}</p>
							</div>
						
							<div class='input'>
								<div class="relative">
									<input id="awarding-body-mobile" name="awarding_body" bind:value={awardingBody} placeholder="Awarding Body" class="peer z-20 placeholder:text-transparent {awardingBodyError === '' ? '' : 'border-red-600'}"/>
									<label for="awarding-body-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Awarding Body</label>
								</div>
								<p class='error-text {awardingBodyError === '' ? 'hidden' : ''}'>{awardingBodyError}</p>
							</div>
							<div class='input'>
								<div class="relative">
									<input id="contractor-mobile" name="contractor" bind:value={contractor} placeholder="Contractor Name" class="peer z-20 placeholder:text-transparent  {contractorError === '' ? '' : 'border-red-600'}"/>
									<label for="contractor-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Contractor</label>
								</div>
								<p class='error-text {contractorError === '' ? 'hidden' : ''}'>{contractorError}</p>
							</div>
							<div class='input'>
								<div class="relative">
									<input id="project-name-mobile" name="proj_name" bind:value={projectName} placeholder="Project Name" class="peer z-20 placeholder:text-transparent  {projectNameError === '' ? '' : 'border-red-600'}"/>
									<label for="project-name-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Project Name</label>
								</div>
								<p class='error-text {projectNameError === '' ? 'hidden' : ''}'>{projectNameError}</p>
							</div>
							<div class='input'>
								<div class="relative">
									<select id="county-mobile" name="county" bind:value={county} class="input-field peer mt-4 {countyError === '' ? '' : 'border-red-600'} w-full">
										<option value="">Select a County</option><option value="Out of state:">Out of state:</option><option value="Alameda">Alameda</option><option value="Alpine">Alpine</option><option value="Amador ">Amador </option><option value="Butte">Butte</option><option value="Calaveras">Calaveras</option><option value="Colusa">Colusa</option><option value="Contra costa">Contra costa</option><option value="Del Norte">Del Norte</option><option value="El Dorado">El Dorado</option><option value="Fresno">Fresno</option><option value="Glenn">Glenn</option><option value="Humboldt">Humboldt</option><option value="Imperial">Imperial</option><option value="Inyo">Inyo</option><option value="Kern">Kern</option><option value="Kings">Kings</option><option value="Lake">Lake</option><option value="Lassen">Lassen</option><option value="Los Angeles">Los Angeles</option><option value="Madera">Madera</option><option value="Marin">Marin</option><option value="Mariposa">Mariposa</option><option value="Mendocino">Mendocino</option><option value="Merced">Merced</option><option value="Modoc">Modoc</option><option value="Mono">Mono</option><option value="Monterey">Monterey</option><option value="Napa">Napa</option><option value="Nevada">Nevada</option><option value="Orange">Orange</option><option value="Placer">Placer</option><option value="Plumas">Plumas</option><option value="Riverside">Riverside</option><option value="Sacramento">Sacramento</option><option value="San Benito">San Benito</option><option value="San Bernardino">San Bernardino</option><option value="San Diego">San Diego</option><option value="San Francisco">San Francisco</option><option value="San Joaquin">San Joaquin</option><option value="San Luis Obispo">San Luis Obispo</option><option value="San Mateo">San Mateo</option><option value="Santa Barbara">Santa Barbara</option><option value="Santa Clara">Santa Clara</option><option value="Santa Cruz">Santa Cruz</option><option value="Shasta">Shasta</option><option value="Sierra">Sierra</option><option value="Siskiyou">Siskiyou</option><option value="Solano">Solano</option><option value="Sonoma">Sonoma</option><option value="Stanislaus">Stanislaus</option><option value="Sutter">Sutter</option><option value="Tehama">Tehama</option><option value="Trinity">Trinity</option><option value="Tulare">Tulare</option><option value="Tuolumne">Tuolumne</option><option value="Ventura">Ventura</option><option value="Yolo">Yolo</option><option value="Yuba">Yuba</option>
									</select>
									<label for="county-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">County</label>
								</div>
								<p class='error-text {countyError === '' ? 'hidden' : ''}'>{countyError}</p>
							</div>
							<div class='input'>
								<div class="relative">
									<input id="start-date-mobile" name="start_date" bind:value={startDate} placeholder="Start Date" type='date' class="{startDateError === '' ? '' : 'border-red-600'}"/>
									<label for="start-date-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Start Date</label>
								</div>
								<p class='error-text {startDateError === '' ? 'hidden' : ''}'>{startDateError}</p>
							</div>
							<div class='input'>
								<div class="relative">
									<input id="end-date-mobile" name="end_date" bind:value={endDate} placeholder="End Date" type='date' class="{endDateError === '' ? '' : 'border-red-600'}"/>
									<label for="end-date-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">End Date</label>
								</div>
								<p class='error-text {endDateError === '' ? 'hidden' : ''}'>{endDateError}</p>
							</div>
							<div class='input'>
								<div class="relative">
									<select id="sort_by-mobile" name="sort_by" bind:value={sortByInput} class="input-field w-full mt-4 {sortByError === '' ? '' : 'border-red-600'}">
										<option value="">Select a Sort Filter</option><option value="DIR Project ID">DIR Project ID</option><option value="Awarding Body">Awarding Body</option><option value="Contractor Name">Contractor Name</option><option value="Project Name">Project Name</option><option value="Date">Date</option><option value="Contractor PWCR">Contractor PWCR</option><option value="County">County</option><option value="CSLB License">CSLB License</option>
									</select>
									<label for="sort_by-mobile" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-5 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65]">Sort By</label>
								</div>
								<p class='error-text {sortByError === '' ? 'hidden' : ''}'>{sortByError}</p>
							</div>
							<div class="input inline-block">
								<div class="flex my-auto text-lg space-x-4 {sepNPError === '' ? '' : 'border-red-600'}">
									<input id="separate-np-mobile" name="sep_np" bind:checked={sepNP} type="checkbox" class="w-6"/>
									<label for="separate-np-mobile">Separate Non-Performance Statements</label>
									<p class='error-text {sepNPError === '' ? 'hidden' : ''}'>{sepNPError}</p>
								</div>
							</div>
							<div class="input inline-block">
								<div class="flex my-auto text-lg space-x-4 {scrapePDFsError === '' ? '' : 'border-red-600'}">
									<input id="scrape-pdfs-mobile" name="scrape_pdfs" bind:checked={scrapePDFs} type="checkbox" class="w-5"/>
									<label for="scrape-pdfs-mobile">Scrape PDFs to CSV</label>
									<p class='error-text {scrapePDFsError === '' ? 'hidden' : ''}'>{scrapePDFsError}</p>
								</div>
							</div>
							<div class="input inline-block">
								<div class="flex my-auto text-lg space-x-4 {includePDFsError === '' ? '' : 'border-red-600'}">
									<input id="include-pdfs-mobile" name="include_pdfs" bind:checked={includePDFs} type="checkbox" class="w-5"/>
									<label for="include-pdfs-mobile">Include PDFs</label>
									<p class='error-text {includePDFsError === '' ? 'hidden' : ''}'>{includePDFsError}</p>
								</div>
							</div>
							<div class="input inline-block">
								<div class="flex my-auto text-lg space-x-4 {contractorTreeFeature ? '' : 'hover:cursor-not-allowed'} {generateContractorTreeError === '' ? '' : 'border-red-600'}">
								<input id="generate-contractor-tree-mobile" name="generate_contractor_tree" bind:checked={generateContractorTree} disabled={!contractorTreeFeature} type="checkbox" class="w-5"/>
								<label for="generate-contractor-tree-mobile" class="{contractorTreeFeature ? '' : 'text-gray-500'}">Generate Contractor Tree</label>
								<p class='error-text {generateContractorTreeError === '' ? 'hidden' : ''}'>{generateContractorTreeError}</p>
								</div>
							</div>
							{#if limitBypassFeature}
							<div class="input inline-block">
								<div class="flex my-auto text-lg space-x-4 {limitBypassError === '' ? '' : 'border-red-600'}">
									<input id="limit-bypass-mobile" name="scrape_pdfs" bind:checked={limitBypass} type="checkbox" class="w-5"/>
									<label for="limit-bypass-mobile">BETA - 250 Limit Bypass</label>
									<p class='error-text {limitBypassError === '' ? 'hidden' : ''}'>{limitBypassError}</p>
								</div>
							</div>
							{/if}
							<div class="input inline-block">
								<div class="flex my-auto text-lg space-x-4 {useV2ParserError === '' ? '' : 'border-red-600'}">
									<input id="use-v2-parser-mobile" name="use_v2_parser" bind:checked={useV2Parser} type="checkbox" class="w-5"/>
									<label for="use-v2-parser-mobile">BETA - Use v2 Parser</label>
									<p class='error-text {useV2ParserError === '' ? 'hidden' : ''}'>{useV2ParserError}</p>
								</div>
							</div>
							<div class="input inline-block">
								<div class="flex my-auto text-lg space-x-4 {localSearchError === '' ? '' : 'border-red-600'}">
									<input id="local-search-mobile" name="local_search" bind:checked={localSearch} type="checkbox" class="w-5"/>
									<label for="local-search-mobile">BETA - Local Search</label>
									<p class='error-text {localSearchError === '' ? 'hidden' : ''}'>{localSearchError}</p>
								</div>
							</div>
							<input type="submit" value="Submit" disabled={previewSubmit}
								class="w-5/12 pl-0 pb-2 pt-1 text-xl rounded-md bg-blue-500 disabled:bg-blue-300 disabled:text-white hover:bg-blue-700 cursor-pointer disabled:cursor-wait text-white font-semibold border-none shadow-sm">
						</div>
					</form>
				</div>
				<div class="{searchState === 'preview-data' ? '' : 'hidden'}">
					<p class="text-2xl font-semibold text-blue-900">Preview eCPR Documents</p>
					<p class="text-lg font-semibold text-blue-900 mb-4">Click on a row to expand.</p>
					<p class="text-red-500 {otherError === '' ? '' : 'text-xl pb-5'}">{otherError}</p>
					<p class="text-blue-600 {previewDataNotice === '' ? '' : 'text-xl pb-5'}">{previewDataNotice}</p>
					<p class="text-lg mb-3">{previewData.length} {previewData.length == 1 ? "result" : "results"}</p>
					<div class="overflow-auto max-h-[50vh]">
						<SvelteTable
							columns={mobileCols}
							rows={previewData}
							classNameRow={'text-lg text-center'}
							classNameThead={['table-primary sticky top-0 bg-white']}
							classNameTbody={['w-full overflow-scroll']}
							classNameSelect={['rounded-md shadow-sm font-thin py-1 px-2']}
							classNameRowExpanded={'bg-gray-400'}
							classNameExpandedContent={'bg-gray-200'}
							classNameCell={'py-2'}
							expandRowKey="id"
							bind:expanded={expandedArr}
							on:clickRow={(event) => {
								handleRowClick(event);
								let row = event.detail.row; 
							}}
						>
						<svelte:fragment slot="expanded" let:row>
							<div class="flex flex-col space-y-2 text-lg">
								<p>Entry Date: {row.submissionDate}</p> 
								<p>Project ID: {row.projectID}</p>
								<p>Project Name: {row.projectName}</p>
								<p>Awarding Body: {row.awardingBody}</p>
								
								<button class="py-2" on:click={() => {
									document.getElementById("TID").value = row.tranId;
									document.getElementById("PAN").value = row.payrollNumAmendNum;
									document.getElementById("getPDF").submit();
								}}>Preview PDF File</button>
							</div>
						</svelte:fragment>
						</SvelteTable>
					</div>
					<form id="getPDF" action="https://efiling.dir.ca.gov/eCPR/ActionServlet?action=getCertPayrollRecords" target="_blank" method="post" class="hidden">
						<input type="hidden" id="TID" name="TID" value="">
						<input type="hidden" id="RM" name="RM" value="">
						<input type="hidden" id="PAN" name="PAN" value="">
					</form>
					<div class="inline-block w-full mt-4 space-x-6">
						<button on:click={() => {searchState = 'preview-search'; previewData = []; otherError = ''}}
							class="w-5/12 pl-0 pb-2 pt-1 text-xl rounded-md bg-blue-500 disabled:bg-blue-300 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
						Back</button>
						<button on:click={handleSearch} disabled={searchSubmit}
							class="float-right w-5/12 pl-0 pb-2 pt-1 text-xl rounded-md bg-blue-500 disabled:bg-blue-300 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
						Submit Search</button>
					</div>
				</div>
				<div class="{searchState === 'aggregating-results' ? '' : 'hidden'}">
					<p class="text-2xl font-semibold text-blue-900">Aggregating Results</p>
					<p class="text-red-500 {otherError === '' ? '' : 'text-xl pb-5'}">{otherError}</p>
					<div class="mt-5 space-y-3">
						<p class="text-xl font-semibold">Search ID: {searchId.substring(16)}</p>
						<p class="text-xl font-semibold">Status: {capitalizeFirstLetter(searchStatus)}</p>
						{#if searchStatus === 'downloading'}
							<p class="text-xl font-semibold">Files downloaded: {downloadedFiles} out of {totalFiles}</p>
						{:else if searchStatus === 'finished'}
							<div class="space-x-2 mt-5">
								<a href="{getGETAPILink('ecpr-search/download', {'search_id': searchId})}" download="{searchId}.zip" target="_self">
								<button
									class="w-5/12 pl-0 pb-2 pt-2 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
								Download</button></a>
								<button on:click={newSearch}
									class="w-6/12 pl-0 pb-2 pt-2 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
								New Search</button>
							</div>
						{/if}
						{#if (searchStatus !== 'finished') && (searchStatus !== 'error')}
							<div class="inline-block w-full mt-5">
								<button on:click={() => cancelSearch(searchId)} disabled={cancelSubmit}
									class="w-5/12 pl-0 pb-2 pt-1 text-xl rounded-md bg-blue-500 hover:bg-blue-700 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
								Cancel</button>
							</div>
						{/if}
					</div>
				</div>
			</div>
		</div>
	</div>
	<Footer/>
</main>

<style>
	main.background { 
		background-color:theme("colors.gray.100");
	}
	.input-field {
		@apply rounded-md shadow-sm font-thin py-1 px-2;
	}
</style>